module.exports = __webpack_public_path__ + "static/img/newSet.25f5ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newSet.png
// module id = JA/f
// module chunks = 1